const referral_code = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_REFERRAL_CODE':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default referral_code;